type DebugInfoProps = {
  error: unknown;
  status?: number;
  isDev: boolean;
};

export function DebugInfo({ error, status, isDev }: DebugInfoProps) {
  const errorValueDisplay =
    error === null
      ? "null"
      : error === undefined
        ? "undefined"
        : String(error).substring(0, 100);

  return (
    <div className="rounded border border-orange-300 bg-orange-50 p-4">
      <h4 className="mb-2 font-semibold text-orange-800">Debug Info:</h4>
      <div className="space-y-1 text-xs text-orange-700">
        <p>
          <strong>Error provided:</strong> {error !== undefined ? "Yes" : "No"}{" "}
          ({typeof error})
        </p>
        <p>
          <strong>Status provided:</strong>{" "}
          {status !== undefined ? `Yes (${status})` : "No"}
        </p>
        <p>
          <strong>isDev:</strong> {String(isDev)}
        </p>
        <p>
          <strong>Error value:</strong> {errorValueDisplay}
        </p>
      </div>
    </div>
  );
}
